export const SKELETON_SURFACE_SX = { bgcolor: 'background.default' };

export const SKELETON_CHECKBOX_SIZE = 16;
export const SKELETON_CHECKBOX_RADIUS = 3;
export const SKELETON_CHECKBOX_SLOT_SIZE = 24;
export const SKELETON_IMAGE_WIDTH = 38;
export const SKELETON_IMAGE_SQUARE_WIDTH = 53;
export const SKELETON_IMAGE_HEIGHT = 60;
export const SKELETON_IMAGE_GAP = 8;
export const SKELETON_LABEL_HEIGHT = 17;
export const SKELETON_INFO_ROW_GAP = 4;
export const SKELETON_TAG_HEIGHT = 16;
export const SKELETON_TAG_WIDTHS = [39, 69, 23];
export const SKELETON_GRID_FALLBACK_WIDTH = 254;
export const SKELETON_GRID_CELL_HEIGHT = 50;
export const SKELETON_GRID_CELL_TOUCH_HEIGHT = 78;
export const SKELETON_GRID_CELL_GAP = 2;
export const SKELETON_GRID_BUTTON_WIDTH = 60;
export const SKELETON_GRID_BUTTON_HEIGHT = 28;
export const SKELETON_GRID_BUTTON_GAP = 28;
export const SKELETON_TOTALS_LINE_HEIGHT = 16;
export const SKELETON_TOTALS_LINE_WIDTHS = [61, 83, 61];
export const SKELETON_TOTALS_GAP = 5;
export const SKELETON_ACTIONS_SIZE = 28;
export const SKELETON_ROW_COUNT = 8;
